export enum ENotificationTemplateKey {
  NewVideo = 'new-video',
  LiveStreamWillStart = 'live-stream-will-start',
  LiveStreamStarted = 'live-stream-started',
  NewBlogArticle = 'new-blog',
  VideoCommentReply = 'video-comment-reply',
  CommunityPostCommentReply = 'community-post-comment-reply',
}
